import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var more_vertical_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M13 19h-2v-2h2v2zm0-6h-2v-2h2v2zm0-6h-2V5h2v2z" }) });
export {
  more_vertical_default as default
};
//# sourceMappingURL=more-vertical.js.map
